import { Outlet, redirect } from 'react-router'
import { createClient } from '@/api-client'
import { Me } from '@/api-client/Me'
import { SubscriptionMypageLayout as Layout } from '~/components/subscription/mypage-layout'

export const loader = async () => {
  try {
    return await fetchMe()
  } catch {
    return redirect('/subscription/login')
  }
}

async function fetchMe() {
  return createClient(Me).getMe()
}

export const SubscriptionMypageLayout: React.FC = () => {
  return (
    <Layout>
      <Outlet />
    </Layout>
  )
}
